export const customConfig = ({typography, palette, ...theme}) => ({
  ...theme,
  typography: {
    ...typography,
    overline: {
      fontSize: "1.5rem"
    },
    caption: {
      fontSize: "0.87rem"
    },
    body2: {
      ...typography.body2,
      fontSize: "1rem"
    },
    h4: {
      ...typography.h4,
      fontSize: "1.5rem"
    },
    h5: {
      ...typography.h5,
      fontSize: "1.15rem"
    },
    h6: {
      ...typography.h5,
      fontSize: "1rem",
      fontFamily: typography.bold,
    }
  },
  palette: {
    ...palette,
    secondary: {
      ...palette.secondary,
      main: "#EB0052"
    },
    text: {
      ...palette.text,
      secondary: palette.text.primary
    }
  }
});
